import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Typography,
    Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DrugSynonym } from '../../../application/types/drug';

interface SynonymListProps {
    synonyms: DrugSynonym[];
    onEdit: (synonym: DrugSynonym) => void;
    onDelete: (synonym: DrugSynonym) => void;
    disabled?: boolean;
}

const SynonymList: React.FC<SynonymListProps> = ({
    synonyms,
    onEdit,
    onDelete,
    disabled = false,
}) => {
    if (synonyms.length === 0) {
        return (
            <Box sx={{ py: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    Inga synonymer registrerade
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer component={Paper} variant="outlined">
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Produktnamn</TableCell>
                        <TableCell>Streckkod</TableCell>
                        <TableCell>GTIN</TableCell>
                        <TableCell align="right">Åtgärder</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {synonyms.map((synonym) => (
                        <TableRow key={synonym.id}>
                            <TableCell>{synonym.produktName || '-'}</TableCell>
                            <TableCell>{synonym.barCode || '-'}</TableCell>
                            <TableCell>{synonym.gtin || '-'}</TableCell>
                            <TableCell align="right">
                                <IconButton
                                    size="small"
                                    onClick={() => onEdit(synonym)}
                                    disabled={disabled}
                                    title="Redigera"
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                    size="small"
                                    onClick={() => onDelete(synonym)}
                                    disabled={disabled}
                                    title="Ta bort"
                                    color="error"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SynonymList;
